import { createContext } from 'react';

type ActionButton = {
  callback?: Function;
  text?: string;
  isDisabled?: boolean;
};

export type ModalWindowItem = {
  ModalContent: () => JSX.Element;
  title: string;
  onCancelButtonParams?: ActionButton;
  onConfirmButtonParams?: ActionButton;
  onCloseCallback?: () => void;
  modalType?: 'default' | 'confirmation'
};

export type ModalWindowItemInternal = ModalWindowItem & {
  id: UUID;
};

interface IModalWindowApiContext {
  readonly close: (id: UUID) => void;
  readonly add: (newModal: ModalWindowItemInternal) => UUID;
  readonly clearAll: () => void;
}

export const ModalWindowApiContext =
  createContext<IModalWindowApiContext | undefined>(undefined);
